import {OptionsService} from "./service/OptionsService";
import {OptionContractsCache} from "./cache/OptionContractsCache";

import Components from "./components";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.contracts`;

    return angular.module(moduleName, [Components(moduleName)])
                  .service(OptionsService.id, OptionsService)
                  .service(OptionContractsCache.id, OptionContractsCache)
                  .name;
}
